import React from 'react'
import { Button, Modal, Segment } from 'semantic-ui-react'

import { tr } from '../../helpers/languages'

const ErrorModal = (props) => {
    return (
        <Modal className='logout' open onClose={(_e) => { props.onClose() }}>
            <Modal.Content>
                <Segment className='logout-title'>
                    {tr('ERROR')}
                </Segment>
                <Segment className='logout-text'>
                    {props.text}
                </Segment>
                <Segment className='logout-buttons right aligned'>
                    <Button className='save-changes' onClick={(_e) => { props.onOk() }}>
                        {tr('OK')}
                    </Button>
                </Segment>
            </Modal.Content>
        </Modal>
    )
}

export default ErrorModal



// WEBPACK FOOTER //
// ./src/components/error-modal/index.js